<template>
  <div class="heart-toast-container">
    <!-- 支持多个气泡同时显示 -->
    <div
      v-for="bubble in activeBubbles"
      :key="bubble.id"
      class="heart-toast-overlay"
    >
      <div
        class="heart-toast-card"
        :class="bubble.type"
        :style="bubble.style"
      >
        <div class="toast-content">
          <span class="toast-icon">{{ bubble.icon }}</span>
          <span class="toast-text">{{ bubble.message }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeartClickToast',
  data () {
    return {
      activeBubbles: [], // 🎈 存储所有活跃的气泡
      bubbleIdCounter: 0 // 🎯 气泡ID计数器
    }
  },
  methods: {
    // 显示发送思念提示
    showSendToast (intensity = 0) {
      const sendMessages = [
        { text: '思念轻轻飞向Ta', icon: '🌙' },
        { text: '想念在心中荡漾', icon: '💙' },
        { text: '思念如潮水般涌来', icon: '🌊' },
        { text: '此刻特别想Ta', icon: '💕' }
      ]

      const messageData = sendMessages[intensity] || sendMessages[0]
      this.createBubble(messageData.text, messageData.icon, 'send')
    },

    // 显示接收思念提示
    showReceiveToast (newIntensity, isComplete) {
      let messageData = { text: '收到了思念', icon: '💝' }

      if (isComplete) {
        messageData = { text: '思念已全部传达', icon: '✨' }
      } else if (newIntensity > 1) {
        messageData = { text: `还有 ${newIntensity} 份思念在跳动`, icon: '💕' }
      }

      this.createBubble(messageData.text, messageData.icon, 'receive')
    },

    // 🎈 创建新气泡
    createBubble (message, icon, type = 'send') {
      // 生成唯一ID
      const bubbleId = ++this.bubbleIdCounter

      // 🎲 生成随机位置
      const randomX = Math.random() * (window.innerWidth - 200) - (window.innerWidth - 200) / 2
      const randomY = Math.random() * (window.innerHeight - 300) - (window.innerHeight - 300) / 2

      // 创建气泡对象
      const bubble = {
        id: bubbleId,
        message,
        icon,
        type,
        style: {
          transform: `translateX(${randomX}px) translateY(${randomY}px) scale(0.1)`,
          opacity: '0',
          transition: 'none'
        },
        timers: []
      }

      // 添加到活跃气泡数组
      this.activeBubbles.push(bubble)

      // 🎯 iPhone风格弹出动画
      const timer1 = setTimeout(() => {
        const bubbleIndex = this.activeBubbles.findIndex(b => b.id === bubbleId)
        if (bubbleIndex !== -1) {
          this.activeBubbles[bubbleIndex].style = {
            transform: `translateX(${randomX}px) translateY(${randomY}px) scale(1)`,
            opacity: '1',
            transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)'
          }
        }
      }, 50)

      // 🌟 开始淡出
      const timer2 = setTimeout(() => {
        const bubbleIndex = this.activeBubbles.findIndex(b => b.id === bubbleId)
        if (bubbleIndex !== -1) {
          this.activeBubbles[bubbleIndex].style = {
            transform: `translateX(${randomX}px) translateY(${randomY}px) scale(0.95)`,
            opacity: '0',
            transition: 'all 0.3s ease-out'
          }
        }
      }, 1500)

      // 🌟 完全移除
      const timer3 = setTimeout(() => {
        this.removeBubble(bubbleId)
      }, 1850)

      // 存储定时器引用
      bubble.timers = [timer1, timer2, timer3]
    },

    // 🗑️ 移除指定气泡
    removeBubble (bubbleId) {
      const bubbleIndex = this.activeBubbles.findIndex(b => b.id === bubbleId)
      if (bubbleIndex !== -1) {
        // 清理该气泡的所有定时器
        this.activeBubbles[bubbleIndex].timers.forEach(timer => {
          clearTimeout(timer)
        })
        // 从数组中移除
        this.activeBubbles.splice(bubbleIndex, 1)
      }
    },

    // 🧹 清理所有气泡
    clearAllBubbles () {
      this.activeBubbles.forEach(bubble => {
        bubble.timers.forEach(timer => {
          clearTimeout(timer)
        })
      })
      this.activeBubbles = []
    }
  },

  beforeDestroy () {
    this.clearAllBubbles()
  }
}
</script>

<style scoped>
/* 🎯 多气泡容器 */
.heart-toast-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1000;
}

/* 🎈 单个气泡覆盖层 */
.heart-toast-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 100;
}

.heart-toast-card {
  /* 🌟 超强磨砂玻璃效果 */
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.08) 30%,
    rgba(240, 248, 255, 0.12) 70%,
    rgba(248, 250, 252, 0.18) 100%
  );
  backdrop-filter: blur(60px) saturate(250%) brightness(1.2) contrast(1.1);
  -webkit-backdrop-filter: blur(60px) saturate(250%) brightness(1.2) contrast(1.1);

  /* 🎨 精致边框 */
  border: 1.5px solid;
  border-image: linear-gradient(135deg,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.4) 100%
  ) 1;
  border-radius: 24px;

  /* 🎯 优雅间距 */
  padding: 14px 22px;

  /* ✨ 多层次阴影 */
  box-shadow:
    /* 外部光晕 */
    0 0 60px rgba(255, 255, 255, 0.2),
    0 25px 50px rgba(255, 255, 255, 0.15),
    0 15px 35px rgba(0, 0, 0, 0.02),
    0 8px 25px rgba(0, 0, 0, 0.03),
    0 3px 15px rgba(0, 0, 0, 0.04),
    /* 内部高光 */
    inset 0 2px 0 rgba(255, 255, 255, 0.8),
    inset 0 -1px 0 rgba(255, 255, 255, 0.4),
    inset 0 0 0 1px rgba(255, 255, 255, 0.2);

  /* 🎭 动画性能优化 */
  will-change: transform, opacity, filter;
  transform-origin: center center;

  /* 🍎 苹果级细节 */
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'PingFang SC', sans-serif;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;

  /* 🌈 结构 */
  position: relative;
  overflow: hidden;

  /* 🎈 气泡特效预设 */
  filter: drop-shadow(0 8px 32px rgba(255, 255, 255, 0.1));
}

.toast-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.toast-icon {
  font-size: 20px;
  line-height: 1;
  flex-shrink: 0;
  /* 🌟 炫彩发光图标 */
  filter:
    drop-shadow(0 3px 12px rgba(255, 105, 180, 0.6))
    drop-shadow(0 0 20px rgba(255, 255, 255, 0.8))
    drop-shadow(0 1px 6px rgba(255, 255, 255, 1));

  /* 🎭 微妙的脉动效果 */
  animation: iconGlowSend 3s ease-in-out infinite alternate;
  transform: translateZ(0);
}

.toast-text {
  font-size: 15px;
  font-weight: 600;
  color: rgba(60, 80, 120, 0.95);
  line-height: 1.3;

  /* ✨ 梦幻文字效果 */
  text-shadow:
    0 2px 4px rgba(255, 255, 255, 1),
    0 1px 8px rgba(255, 255, 255, 0.6),
    0 0 16px rgba(255, 255, 255, 0.3);

  letter-spacing: 0.3px;
  white-space: nowrap;

  /* 🎯 文字质感 */
  background: linear-gradient(135deg,
    rgba(60, 80, 120, 0.95) 0%,
    rgba(74, 85, 104, 0.9) 50%,
    rgba(90, 110, 140, 0.85) 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* 🎨 发送和接收状态的精致微调 */
.heart-toast-card.send {
  /* 💙 发送状态 - 清新蓝调 */
  background: linear-gradient(135deg,
    rgba(102, 126, 234, 0.12) 0%,
    rgba(255, 255, 255, 0.08) 30%,
    rgba(240, 248, 255, 0.15) 70%,
    rgba(248, 250, 252, 0.18) 100%
  );
  border-image: linear-gradient(135deg,
    rgba(102, 126, 234, 0.5) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(102, 126, 234, 0.4) 100%
  ) 1;
  filter: drop-shadow(0 8px 32px rgba(102, 126, 234, 0.15));
}

.heart-toast-card.receive {
  /* 💖 接收状态 - 温暖粉调 */
  background: linear-gradient(135deg,
    rgba(236, 72, 153, 0.12) 0%,
    rgba(255, 255, 255, 0.08) 30%,
    rgba(255, 240, 248, 0.15) 70%,
    rgba(248, 250, 252, 0.18) 100%
  );
  border-image: linear-gradient(135deg,
    rgba(236, 72, 153, 0.5) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(236, 72, 153, 0.4) 100%
  ) 1;
  filter: drop-shadow(0 8px 32px rgba(236, 72, 153, 0.15));
}

.heart-toast-card.send .toast-icon {
  filter:
    drop-shadow(0 3px 12px rgba(102, 126, 234, 0.7))
    drop-shadow(0 0 20px rgba(102, 126, 234, 0.4))
    drop-shadow(0 1px 6px rgba(255, 255, 255, 1));
  animation: iconGlowSend 3s ease-in-out infinite alternate;
}

.heart-toast-card.receive .toast-icon {
  filter:
    drop-shadow(0 3px 12px rgba(236, 72, 153, 0.7))
    drop-shadow(0 0 20px rgba(236, 72, 153, 0.4))
    drop-shadow(0 1px 6px rgba(255, 255, 255, 1));
  animation: iconGlowReceive 3s ease-in-out infinite alternate;
}

/* 🎭 状态特定动画 */
@keyframes iconGlowSend {
  0% {
    filter:
      drop-shadow(0 3px 12px rgba(102, 126, 234, 0.7))
      drop-shadow(0 0 20px rgba(102, 126, 234, 0.4))
      drop-shadow(0 1px 6px rgba(255, 255, 255, 1));
  }
  100% {
    filter:
      drop-shadow(0 4px 16px rgba(102, 126, 234, 0.9))
      drop-shadow(0 0 28px rgba(102, 126, 234, 0.6))
      drop-shadow(0 2px 10px rgba(255, 255, 255, 1));
  }
}

@keyframes iconGlowReceive {
  0% {
    filter:
      drop-shadow(0 3px 12px rgba(236, 72, 153, 0.7))
      drop-shadow(0 0 20px rgba(236, 72, 153, 0.4))
      drop-shadow(0 1px 6px rgba(255, 255, 255, 1));
  }
  100% {
    filter:
      drop-shadow(0 4px 16px rgba(236, 72, 153, 0.9))
      drop-shadow(0 0 28px rgba(236, 72, 153, 0.6))
      drop-shadow(0 2px 10px rgba(255, 255, 255, 1));
  }
}

/* 🌈 超强磨砂玻璃光影效果 */
.heart-toast-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 70%;
  background: linear-gradient(160deg,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 255, 255, 0.4) 30%,
    rgba(255, 255, 255, 0.1) 70%,
    rgba(255, 255, 255, 0) 100%
  );
  border-radius: 24px 24px 0 0;
  pointer-events: none;
  /* 🎯 光影微动画 */
  animation: shimmer 4s ease-in-out infinite alternate;
}

.heart-toast-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40%;
  background:
    radial-gradient(ellipse at center bottom,
      rgba(255, 255, 255, 0.4) 0%,
      rgba(255, 255, 255, 0.2) 40%,
      rgba(255, 255, 255, 0) 100%
    ),
    linear-gradient(0deg,
      rgba(255, 255, 255, 0.35) 0%,
      rgba(255, 255, 255, 0.1) 60%,
      rgba(255, 255, 255, 0) 100%
    );
  border-radius: 0 0 24px 24px;
  pointer-events: none;
}

/* 🎭 通用动画效果 */

@keyframes shimmer {
  0% {
    opacity: 0.8;
    transform: translateX(-2px);
  }
  100% {
    opacity: 1;
    transform: translateX(2px);
  }
}

/* 📱 移动端磨砂玻璃优化 */
@media (max-width: 480px) {
  .heart-toast-card {
    padding: 12px 18px;
    border-radius: 20px;

    /* 🌟 移动端磨砂效果 */
    backdrop-filter: blur(45px) saturate(220%) brightness(1.15);
    -webkit-backdrop-filter: blur(45px) saturate(220%) brightness(1.15);

    /* 🎨 优化背景 */
    background: linear-gradient(135deg,
      rgba(255, 255, 255, 0.18) 0%,
      rgba(255, 255, 255, 0.1) 30%,
      rgba(240, 248, 255, 0.15) 70%,
      rgba(248, 250, 252, 0.2) 100%
    );

    /* ✨ 增强阴影 */
    box-shadow:
      0 0 40px rgba(255, 255, 255, 0.25),
      0 20px 40px rgba(255, 255, 255, 0.18),
      0 10px 25px rgba(0, 0, 0, 0.02),
      0 5px 15px rgba(0, 0, 0, 0.03),
      inset 0 2px 0 rgba(255, 255, 255, 0.9),
      inset 0 -1px 0 rgba(255, 255, 255, 0.5);
  }

  .toast-icon {
    font-size: 18px;
  }

  .toast-text {
    font-size: 14px;
    font-weight: 500;
  }

  .heart-toast-card::before {
    border-radius: 20px 20px 0 0;
    background: linear-gradient(160deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgba(255, 255, 255, 0.5) 30%,
      rgba(255, 255, 255, 0.15) 70%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  .heart-toast-card::after {
    border-radius: 0 0 20px 20px;
  }
}

/* 🔍 超小屏幕适配 */
@media (max-width: 360px) {
  .heart-toast-card {
    padding: 10px 16px;
    border-radius: 18px;
    backdrop-filter: blur(40px) saturate(200%) brightness(1.1);
    -webkit-backdrop-filter: blur(40px) saturate(200%) brightness(1.1);
  }

  .toast-icon {
    font-size: 16px;
  }

  .toast-text {
    font-size: 13px;
    letter-spacing: 0.2px;
  }
}
</style>
